import styles from './readmore.module.css';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ReadMore({ children }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.readMoreContainer}>
      <button onClick={toggleReadMore} className={styles.toggleButton}>
        {isExpanded ? 'Read less...' : 'Read more...'}
      </button>
      {isExpanded && <div>{children}</div>}
    </div>
  );
}